:host {
  display: block;
  width: 100%;
}

.spw-group {
  spw-button:not[is-fullwidth-mobile='false'] {
    display: block;
    width: 100%;
    @include breakpoint(md) {
      display: initial;
      width: auto;
    }
  }

  &__container {
    display: flex;
    width: fit-content;
    @include breakpoint(md) {
      align-items: center;
    }
    .spw-group--buttons & {
      gap: 12px;
      width: 100%;
      @include breakpoint(md) {
        width: fit-content;
      }
    }
    .spw-group--checkboxes &,
    .spw-group--radios & {
      gap: 16px;
    }
    .spw-group--checkboxes.spw-group--horizontal &,
    .spw-group--radios.spw-group--horizontal & {
      gap: 16px;
      @include breakpoint(md) {
        gap: 24px;
      }
    }
    .spw-group--buttons.spw-group--align-right.spw-group--horizontal & {
      flex-direction: column;
      @include breakpoint(md) {
        flex-direction: row-reverse;
      }
    }
  }

  &--align-left {
    .spw-group__container {
      margin-right: auto;
    }
  }

  &--align-center {
    .spw-group__container {
      margin-left: auto;
      margin-right: auto;
    }
  }

  &--align-right {
    .spw-group__container {
      margin-left: auto;
    }
  }

  &--vertical {
    .spw-group__container {
      flex-direction: column;
      align-items: flex-start;

      .spw-group--align-center & {
        align-items: center;
      }

      .spw-group--align-right & {
        align-items: flex-end;
      }
    }
  }

  &--horizontal {
    .spw-group__container {
      flex-direction: column;
      @include breakpoint(md) {
        flex-direction: row;
      }
    }
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
